import { connect } from 'react-redux';
import {
  navigationProgress,
  navigationCompleted,
  navigationPending,
  navigationLoading,
  navigationFetched,
  currentStore,
} from 'core/selectors';
import { getNavigationStatus } from 'core/slices/navigation';
import NavigationStatusCard from '../../../components/navigation/NavigationStatusCard';

const mapStateToProps = state => ({
  navigationProgress: navigationProgress(state),
  navigationCompleted: navigationCompleted(state),
  navigationPending: navigationPending(state),
  navigationLoading: navigationLoading(state),
  navigationFetched: navigationFetched(state),
  currentStore: currentStore(state),
});

export default connect(mapStateToProps, { getNavigationStatus })(NavigationStatusCard);
